const BhVampCheck = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM7.79023 4.98746C7.92138 4.82717 7.89776 4.59091 7.73746 4.45977C7.57717 4.32862 7.34091 4.35224 7.20977 4.51254L5.22216 6.94183L4.51517 6.23483C4.36872 6.08839 4.13128 6.08839 3.98483 6.23483C3.83839 6.38128 3.83839 6.61872 3.98483 6.76517L4.98483 7.76517C5.05975 7.84008 5.16286 7.87981 5.26868 7.87453C5.3745 7.86926 5.47314 7.81946 5.54023 7.73746L7.79023 4.98746Z"
      fill="currentColor"
    />
  </svg>
)

export default BhVampCheck
